import { render, staticRenderFns } from "./OccupationalResolution.vue?vue&type=template&id=7ecba538"
import script from "./OccupationalResolution.vue?vue&type=script&lang=js"
export * from "./OccupationalResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports